export enum CreditorRegistrationSteps {
  CompanyDetails = 0,
  Financials = 1,
  Services = 2,
  Agreement = 3,
  Confirmation = 4,
  Summary = 5,
}
